'use client';

import React from 'react';

import MenuItem from './menu-item';
import { fetchDataFromBuilder, getBuilderCacheBusterKey } from 'src/scripts/utils/builder';
import { useCacheAndNetwork } from 'src/scripts/utils/react/useCacheAndNetwork';
import { DesktopNavMenu } from './NAV_TYPES';

function Menu() {
  // ! [REVISIT] for Sanath, add prefetch?
  // ? themeid as part of cacheKey?
  // ? similar to: `alo-theme-${themeInfo?.id}-apollo-cache-persist-navdata-${apolloCacheKeySegment}`,??
  const { data: L1Items } = useCacheAndNetwork('desktop-nav-data', getBuilderData, {
    // since DesktopNav above the fold & visible; we default more often to cache & the swap could be jarring
    // (cont) & as a multi-page app, they will see the update on next page load
    replaceStaleDataPostFetch: false,
    staleCacheTTL: 1000 * 60 * 60 * 6, // 6 hours, eta on builder downtime
  });

  const fallbackMenuItems = [
    { title: 'Women', url: '/collections/womens-shop-all', items: [] },
    { title: 'Men', url: '/pages/mens', items: [] },
    { title: 'Shoes', url: '/pages/shoes', items: [] },
    { title: 'Bags', url: '/pages/bag-collection', items: [], titleTag: 'NEW' },
  ];

  const menuItems = !L1Items || L1Items.length === 0 ? fallbackMenuItems : L1Items;

  return (
    <ul className="align-items-center main-nav__list" role="navigation">
      {menuItems?.map((link, index) => {
        return <MenuItem key={index} link={link} />;
      })}
    </ul>
  );
}

export default Menu;

const getBuilderData = () =>
  fetchDataFromBuilder<DesktopNavMenu>('desktop-navigation-menu', {
    options: { cb: getBuilderCacheBusterKey() },
    reportIfEmpty: true,
  }).then((resp) => resp?.data?.items ?? []);
